import { useSelector } from 'react-redux'

function CreateJobCheckbox({
  label,
  name = '',
  checked = false,
  disabled = false,
  required = false,
  onChange = () => {},
}) {
  const { jobProps } = useSelector((store) => store.recruitment)

  return (
    <div
      className='custom-control custom-checkbox mb-3'
      style={{ zIndex: '0' }}
    >
      <input
        value={label}
        className='custom-control-input'
        id={label}
        name={name}
        checked={
          checked ||
          jobProps?.find((el) => el?.name === name)?.value ||
          required
        }
        disabled={required}
        type='checkbox'
        onChange={(e) => {
          onChange(e.target.checked, required, name)
        }}
      />
      <label className='custom-control-label' htmlFor={label}>
        {label} {required ? <span className='text-danger'>*</span> : null}
      </label>
    </div>
  )
}

export default CreateJobCheckbox
